let NextImage: unknown;
try {
  NextImage = require("next/image").default;
} catch (_err) {
  // not in a Next environment, so skip
  NextImage = null;
}

export { NextImage };
